import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Echart from 'echarts'

import 'normalize.css'
import '@/styles/index.scss' // global css
import '@/assets/icomoon/iconfont.css'
import '@/plugins/element.js'

import Clipboard from 'vue-clipboard2'
import SvgIcon from 'vue-svgicon'
import '@/icons/ts'

import '@/permission' // permission control

import Toast from '@/plugins/toast' // toast 提示框
import Vconsole from 'vconsole'
import { getAppid } from './utils/utils'
import {
  getuserCurrentApp,
  removeIsSingleEntry,
  removeRole,
  removeuserCurrentApp,
  removeuserCurrentAppName,
  setIsSingleEntry,
  setuserCurrentApp,
  setuserCurrentAppName
} from './utils/cookies'
import { TicketType, TicketTypeEnum } from './utils/commonFunc'
import { remove } from 'nprogress'
Vue.prototype.$echarts = Echart

// import Component from "vue-class-component";
// Vue.config.productionTip = false;
// Component.registerHooks([
//   "beforeRouteEnter", //进入路由以前
//   "beforeRouteLeave", //离开路由以前
//   "beforeRouteUpdate"
// ]);

if (process.env.VUE_APP_ENV !== 'production') {
  new Vconsole()
}

Vue.config.productionTip = false
Clipboard.config.autoSetContainer = true

Vue.use(Clipboard)
Vue.use(Toast)
Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '1em',
  defaultHeight: '1em'
})

const appid = getuserCurrentApp()
const id: string = getAppid()
// 页面刷新  若链接存在id 则设置当前用户所选APP
// 若链接不存在id，

// window.addEventListener("beforeunload", (event) => {
//   // 监听刷新，关闭，跳转等操作
//   // 刷新后，向存储内存一个变量   是刷新操作
//   // 如果是刷新，打开的时候判断  即使浏览器无id  也要 设置id
//   // 每次系统打开都要清空 这个变量
//   // beginTime = new Date().getTime();
//   localStorage.setItem("isRefresh", "true");
//   console.log("beforeunload");
//   // Cancel the event as stated by the standard.
//   event.preventDefault();
//   // Chrome requires returnValue to be set.
//   // event.returnValue = "";
// });

const setCurrentAppFn = (id: string) => {
  console.log(id, 'id main页面')

  setuserCurrentApp(id)
  setIsSingleEntry(id);
  +(
    // let name = TicketType[id];
    id
  ) === (TicketTypeEnum.it as any) &&
    setuserCurrentAppName(TicketType[TicketTypeEnum.it] as any);
  +id === (TicketTypeEnum.live as any) &&
    setuserCurrentAppName(TicketType[TicketTypeEnum.live] as any);
  +id === (TicketTypeEnum.network as any) &&
    setuserCurrentAppName(TicketType[TicketTypeEnum.network] as any);
  +id === (TicketTypeEnum.dashboard as any) &&
    setuserCurrentAppName(TicketType[TicketTypeEnum.dashboard] as any);
  +id === (TicketTypeEnum.administration as any) &&
    setuserCurrentAppName(TicketType[TicketTypeEnum.administration] as any);
  +id === (TicketTypeEnum.fuwubaozhang as any) &&
    setuserCurrentAppName(TicketType[TicketTypeEnum.fuwubaozhang] as any);
  +id === (TicketTypeEnum.caigouguanli as any) &&
    setuserCurrentAppName(TicketType[TicketTypeEnum.caigouguanli] as any);
  +id === (TicketTypeEnum.shengchanguanli as any) &&
    setuserCurrentAppName(TicketType[TicketTypeEnum.shengchanguanli] as any);
  +id === (TicketTypeEnum.shangpinyunying as any) &&
  setuserCurrentAppName(TicketType[TicketTypeEnum.shangpinyunying] as any)
}
if (id) {
  setCurrentAppFn(id)
} else {
  const isRefresh = localStorage.getItem('isRefresh')
  if (isRefresh) {
    setCurrentAppFn(appid)
  } else {
    // 没id并且不是刷新
    removeIsSingleEntry()
    removeuserCurrentApp()
    removeuserCurrentAppName()
    removeRole()
  }
}

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
